module.exports = __webpack_public_path__ + "img/location-icon.64d54041.svg";